import { AdminStore } from 'stylemix-vue-admin'

AdminStore.registerModule('languageSwitcher', {
  namespaced: true,
  state: {
    locales: [],
  },
  mutations: {
    setLocales(state, locales) {
      state.locales = locales
    },
  },
})
